export const createEntityMixin = {
  data () {
    return {
      loading: this.isEditing,
      saving: false,
      files: [],
      bindingFunction: null,
      goBackConfirmed: false,
      axiosMethod: this.axios.post
    }
  },

  methods: {
    getRequiredErrors (property, message = 'Este campo es requerido.') {
      const errors = []
      const formComponent = property.includes('.') ? this.$v[property.split('.')[0]][property.split('.')[1]] : this.$v[property]

      if (!formComponent.$dirty) return errors
      !formComponent.required && errors.push(message)
      return errors
    },
    postSuccessfulSubmit () {
      this.goBack()
      this.saving = false
    },
    sendToAPI (payload, axiosMethod, path) {
      this.saving = true
      axiosMethod(path, payload)
        .then((response) => {
          this.postSuccessfulSubmit(response)
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
          // If we have assets associated with the request, we restart all the uploads.
          if (this.assets) {
            this.assets = []
          }
          this.saving = false
        })
    },
    createAPI (payload) {
      this.sendToAPI(payload, this.axiosMethod, this.createPath)
    },
    editAPI (payload) {
      this.sendToAPI(payload, this.axios.put, this.editPath)
    },
    fetchData () {
      this.loading = true
      this.axios
        .get(this.editPath)
        .then(response => {
          this.setData(response.data)
          this.loading = false
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    submit () {
      this.$v.$touch()
      if (this.isValidForm()) {
        let payload = this.getPayload()
        if (this.isEditing) {
          this.editAPI(payload)
        } else {
          this.createAPI(payload)
        }
      }
    },
    uploadFiles (newFiles) {
      this.files = newFiles
    },
    openFileDirectory () {
      this.$refs.fileInput.onPickFile()
    },
    formatDate (dateFromAPI) {
      if (!dateFromAPI) return null
      let dateParts = dateFromAPI.split('/')
      let dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0])
      return dateObject.toISOString().substr(0, 10)
    },
    goBack () {
      this.goBackConfirmed = true
      this.$router.go(-1)
    },
    goBackConfirmation () {
      if (this.$v.$anyDirty || this.files.length) {
        this.bindingFunction = this.goBack
        this.$refs.confirm.openDialog()
      } else {
        this.goBack()
      }
    },
    formatDateFromAPI (date) {
      if (!date) return null
      const [day, month, year] = date.split('/')
      return `${year}-${month}-${day}`
    }
  },

  created () {
    if (this.isEditing) {
      this.fetchData()
    }
  },

  beforeRouteLeave (to, from, next) {
    if (this.$v.$anyDirty && !this.goBackConfirmed) {
      this.bindingFunction = next
      this.$refs.confirm.openDialog()
    } else {
      next()
    }
  }
}
